// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"e5cd77fb58132e8b806c","8096":"ffcd6f57e510278d60d4"}[chunkId] + ".css";
};